import { AxiosResponse } from 'axios';

export const getHttpResponseResult = <T>(
  response: AxiosResponse,
  bodyProperty?: string
): { success: boolean; data: T } => {
  let success = response?.status === 200;
  let data = null;
  if (success) {
    const getResponseData = <T>(p, res): T => {
      //p 가 undefined 인 경우, response.data 를 리턴한다.
      if (p === undefined) {
        return res?.data;
      } else {
        return res?.data?.body[p];
      }
    };
    data = getResponseData<T>(bodyProperty, response);
  }
  return { success, data };
};
